import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  CSidebar,
  CSidebarHeader,
  CSidebarNav,
  CSidebarFooter,
  CNavTitle,
} from '@coreui/react';
import {
  LayoutDashboard,
  FolderKanban,
  UserPlus,
  ClipboardList,
  LogOut,
  Users,
  Activity,
  UserSearch,
  KeyRound
} from 'lucide-react';

const navConfig = [
  { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard, roles: ['staff', 'rm', 'director', 'hr'] },
  { path: '/projects', label: 'Projects', icon: FolderKanban, roles: ['staff', 'rm', 'director', 'hr'] },
  { path: '/manpower-request', label: 'New Request', icon: UserPlus, roles: ['staff', 'rm', 'director', 'hr'] },
  { path: '/recruitment-cases', label: 'Recruitment', icon: ClipboardList, roles: ['hr', 'rm', 'director'] },
  { path: '/candidate-pool', label: 'Candidate Pool', icon: UserSearch, roles: ['hr', 'rm', 'director'] },
];

const roleLabel = {
  staff: 'Staff',
  rm: 'Area Manager',
  director: 'Director',
  hr: 'HR',
};

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const filteredNav = navConfig.filter(item => item.roles.includes(user?.role));

  return (
    <CSidebar
      data-testid="sidebar-nav"
      className="border-end"
      colorScheme="dark"
      position="fixed"
      style={{ width: '220px' }}
    >
      <CSidebarHeader className="border-bottom border-dark px-3 py-3">
        <div className="d-flex align-items-center gap-2">
          <Activity className="text-info" size={22} />
          <div>
            <div className="fw-bold text-white small lh-1">Manpower</div>
            <div style={{ fontSize: '9px', letterSpacing: '2px' }} className="text-body-secondary text-uppercase">
              Monitor
            </div>
          </div>
        </div>
      </CSidebarHeader>

      <CSidebarNav>
        <CNavTitle className="text-uppercase small mt-2" style={{ fontSize: '10px', letterSpacing: '1px' }}>
          Navigation
        </CNavTitle>
        {filteredNav.map(item => (
          <button
            key={item.path}
            type="button"
            onClick={() => navigate(item.path)}
            data-testid={`nav-${item.path.replace('/', '')}`}
            className={`w-100 text-start border-0 bg-transparent d-flex align-items-center px-3 py-2 ${location.pathname === item.path ? 'text-white' : 'text-body-secondary'}`}
            style={{ fontSize: '15px', gap: '10px' }}
          >
            <item.icon size={16} />
            {item.label}
          </button>
        ))}
      </CSidebarNav>

      <CSidebarFooter className="border-top border-dark px-3 py-3">
        <div className="d-flex align-items-center gap-2 mb-2">
          <Users size={16} className="text-body-secondary" />
          <div>
            <div className="small fw-semibold text-white" data-testid="sidebar-user-name">{user?.name}</div>
            <div style={{ fontSize: '10px' }} className="text-body-secondary text-uppercase">
              {roleLabel[user?.role] || user?.role}
            </div>
            {user?.operatorCode && (
              <div style={{ fontSize: '10px' }} className="text-info mt-1 d-flex align-items-center gap-1">
                <KeyRound size={10} /> {user.operatorCode}
              </div>
            )}
          </div>
        </div>
        <button
          onClick={handleLogout}
          data-testid="logout-button"
          className="btn btn-sm btn-ghost-light w-100 d-flex align-items-center gap-2 text-body-secondary"
          style={{ fontSize: '13px' }}
        >
          <LogOut size={14} /> Change Operator
        </button>
      </CSidebarFooter>
    </CSidebar>
  );
}
